import * as React from 'react'
export const Mg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 512 341.333" width="1em" height="1em" {...props}>
    <path fill="#6DA544" d="M512 426.666V85.329H0v341.337z" />
    <path fill="#D80027" d="M512 85.331H0v170.666h512z" />
    <path fill="#FFF" d="M0 85.334h181.793v341.337H0z" />
  </svg>
)
